// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const BannerDefaultCta = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.bannerDefaultCta"
        description="Banner default cta."
        defaultMessage="Learn more"
    />
);
BannerDefaultCta.displayName = "BannerDefaultCta";

export const NewTagText = (): ReactElement => (
    <FormattedMessage id="apps.shared.components.newTagText" description="New tag text." defaultMessage="New" />
);
NewTagText.displayName = "NewTagText";

export const messages = defineMessages({
    closeAriaText: {
        id: "apps.shared.components.closeAriaText",
        description: "Close aria text.",
        defaultMessage: "Close",
    },
});
